export const SOMETHING_WENT_WRONG_MESSAGE = 'Ceva n-a mers bine';

export const PARTNER_DOCUMENTS_FILTERS = 'partner-documents-filters';
